// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, html {
  min-height: 100vh;
  width: 100%;
  margin: 0;
  padding: 0;
  background: linear-gradient(180deg, #1a2980 0%, #3e5fa8 100%);
  font-family: 'Inter', 'Segoe UI', Arial, sans-serif;
}

.login-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  background: transparent;
  backdrop-filter: blur(16px);
}

.login-modal-container {
  background: linear-gradient(180deg, #102574 0%, #7185A8 100%);
  border-radius: 48px;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.18);
  padding: 85px 85px 85px 85px;
  max-width: 700px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.login-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.combined-logo {
  margin-bottom: 16px;
}

.login-form h3 {
  color: #fff;
  font-size: 32px;
  font-weight: 700;
  font-family: 'Gilroy', sans-serif;
  text-align: center;
}

.login-form label {
  color: #fff;
  font-size: 0.95rem;
  font-weight: 700;
  font-family: 'Gilroy', sans-serif;
  margin-bottom: 8px;
  align-self: flex-start;
}

.login-form input {
  width: 100%;
  padding: 18px 20px;
  margin-bottom: 24px;
  border: none;
  border-radius: 12px;
  background: #f6f7fa;
  font-size: 1rem;
  color: #222;
  box-shadow: 0 2px 8px rgba(30, 60, 120, 0.08);
  outline: none;
  transition: box-shadow 0.2s;
}

.login-form input:focus {
  box-shadow: 0 4px 16px rgba(30, 60, 120, 0.16);
}

.login-form input::placeholder {
  color: #b0b8c9;
  opacity: 1;
}

.login-form button {
  width: 180px;
  padding: 14px 0;
  border: 1px solid #fff;
  background: transparent;
  color: #fff;
  font-size: 20px;
  font-weight: 400;
  border-radius: 12px;
  cursor: pointer;
  margin-top: 8px;
  margin-bottom: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: background 0.2s, color 0.2s, border 0.2s;
}

.login-form button:after {
  content: '\\2192';
  font-size: 1.2em;
  margin-left: 8px;
  transition: margin-left 0.2s;
}

.login-form button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.login-form button:hover:not(:disabled) {
  background: #fff;
  color: #102574;
  border-color: #fff;
}

.login-loading {
  display: flex;
  align-items: center;
  gap: 8px;
}

.spinner-small {
  width: 18px;
  height: 18px;
  border: 3px solid rgba(19, 39, 117, 0.15);
  border-top: 3px solid #132775;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.input-error {
  background-color: #ffeae8 !important;
}

.error {
  color: #ff968f;
  border-radius: 8px;
  width: 100%;
  text-align: center;
  font-weight: 500;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
  transition: background 0.2s, color 0.2s;
  padding: 0;
}

.footer-row-login {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin-top: 16px;
}

.back-button-top-left {
  position: absolute;
  top: 40px;
  left: 40px;
  background: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  color: rgba(255, 255, 255, 0.9) !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  padding: 8px 12px !important;
  border-radius: 50% !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  z-index: 10;
  width: 40px !important;
  height: 40px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: 1 !important;
}

.back-button-top-left:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  color: #fff !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: scale(1.05) !important;
}

.back-button-top-left:after {
  content: none !important;
}

.copyright {
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
}

@media (max-width: 600px) {
  .login-modal-container {
    padding: 48px 48px 48px 48px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Login/Login.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,UAAU;EACV,6DAA6D;EAC7D,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,gDAAgD;EAChD,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,6CAA6C;EAC7C,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,+CAA+C;EAC/C,qDAAqD;EACrD,0CAA0C;EAC1C,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,oCAAoC;EACpC,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,sBAAsB;EACtB,iDAAiD;EACjD,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF","sourcesContent":["body, html {\n  min-height: 100vh;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  background: linear-gradient(180deg, #1a2980 0%, #3e5fa8 100%);\n  font-family: 'Inter', 'Segoe UI', Arial, sans-serif;\n}\n\n.login-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  background: transparent;\n  backdrop-filter: blur(16px);\n}\n\n.login-modal-container {\n  background: linear-gradient(180deg, #102574 0%, #7185A8 100%);\n  border-radius: 48px;\n  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.18);\n  padding: 85px 85px 85px 85px;\n  max-width: 700px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n.login-form {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.combined-logo {\n  margin-bottom: 16px;\n}\n\n.login-form h3 {\n  color: #fff;\n  font-size: 32px;\n  font-weight: 700;\n  font-family: 'Gilroy', sans-serif;\n  text-align: center;\n}\n\n.login-form label {\n  color: #fff;\n  font-size: 0.95rem;\n  font-weight: 700;\n  font-family: 'Gilroy', sans-serif;\n  margin-bottom: 8px;\n  align-self: flex-start;\n}\n\n.login-form input {\n  width: 100%;\n  padding: 18px 20px;\n  margin-bottom: 24px;\n  border: none;\n  border-radius: 12px;\n  background: #f6f7fa;\n  font-size: 1rem;\n  color: #222;\n  box-shadow: 0 2px 8px rgba(30, 60, 120, 0.08);\n  outline: none;\n  transition: box-shadow 0.2s;\n}\n\n.login-form input:focus {\n  box-shadow: 0 4px 16px rgba(30, 60, 120, 0.16);\n}\n\n.login-form input::placeholder {\n  color: #b0b8c9;\n  opacity: 1;\n}\n\n.login-form button {\n  width: 180px;\n  padding: 14px 0;\n  border: 1px solid #fff;\n  background: transparent;\n  color: #fff;\n  font-size: 20px;\n  font-weight: 400;\n  border-radius: 12px;\n  cursor: pointer;\n  margin-top: 8px;\n  margin-bottom: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  transition: background 0.2s, color 0.2s, border 0.2s;\n}\n\n.login-form button:after {\n  content: '\\2192';\n  font-size: 1.2em;\n  margin-left: 8px;\n  transition: margin-left 0.2s;\n}\n\n.login-form button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.login-form button:hover:not(:disabled) {\n  background: #fff;\n  color: #102574;\n  border-color: #fff;\n}\n\n.login-loading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.spinner-small {\n  width: 18px;\n  height: 18px;\n  border: 3px solid rgba(19, 39, 117, 0.15);\n  border-top: 3px solid #132775;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.input-error {\n  background-color: #ffeae8 !important;\n}\n\n.error {\n  color: #ff968f;\n  border-radius: 8px;\n  width: 100%;\n  text-align: center;\n  font-weight: 500;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 18px;\n  transition: background 0.2s, color 0.2s;\n  padding: 0;\n}\n\n.footer-row-login {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  margin-top: 16px;\n}\n\n.back-button-top-left {\n  position: absolute;\n  top: 40px;\n  left: 40px;\n  background: rgba(255, 255, 255, 0.1) !important;\n  border: 1px solid rgba(255, 255, 255, 0.3) !important;\n  color: rgba(255, 255, 255, 0.9) !important;\n  font-size: 18px !important;\n  font-weight: 600 !important;\n  padding: 8px 12px !important;\n  border-radius: 50% !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease !important;\n  z-index: 10;\n  width: 40px !important;\n  height: 40px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  line-height: 1 !important;\n}\n\n.back-button-top-left:hover {\n  background: rgba(255, 255, 255, 0.2) !important;\n  color: #fff !important;\n  border-color: rgba(255, 255, 255, 0.5) !important;\n  transform: scale(1.05) !important;\n}\n\n.back-button-top-left:after {\n  content: none !important;\n}\n\n.copyright {\n  color: #fff;\n  font-size: 14px;\n  font-weight: 400;\n  text-align: center;\n}\n\n@media (max-width: 600px) {\n  .login-modal-container {\n    padding: 48px 48px 48px 48px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
